import {
  ENTER_TRIM_MODE,
  LEAVE_TRIM_MODE,
  SET_SENDING_NEW_TRIM,
  UPDATE_CURRENT_TRIM_RANGE,
  UPDATE_SELECTED_TRIM_BOUND,
  UPDATE_SELECTED_TRIM_RANGE,
  UPDATE_TRIM_NEW_CHANGES,
  UPDATE_TRIM_ORIGINAL_RANGES,
  UPDATE_TRIM_RANGES,
  UPDATE_TRIM_REDO_STACK,
  UPDATE_TRIM_UNDO_STACK,
} from 'constants/actions';

export const setSendingNewTrim = sendingNewTrim => {
  return { type: SET_SENDING_NEW_TRIM, sendingNewTrim };
};

export const enterTrimMode = () => {
  return { type: ENTER_TRIM_MODE };
};

export const leaveTrimMode = () => {
  return { type: LEAVE_TRIM_MODE };
};

export const updateCurrentTrimRange = trimRange => {
  return {
    type: UPDATE_CURRENT_TRIM_RANGE,
    trimRange,
  };
};

export const updateSelectedTrimBound = trimBound => {
  return {
    type: UPDATE_SELECTED_TRIM_BOUND,
    trimBound,
  };
};

export const updateSelectedTrimRange = trimRange => {
  return {
    type: UPDATE_SELECTED_TRIM_RANGE,
    trimRange,
  };
};

export const updateTrimNewChanges = newChanges => {
  return {
    type: UPDATE_TRIM_NEW_CHANGES,
    newChanges,
  };
};

export const updateTrimOriginalRanges = originalRanges => {
  return {
    type: UPDATE_TRIM_ORIGINAL_RANGES,
    originalRanges,
  };
};

export const updateTrimRanges = trimRanges => {
  return {
    type: UPDATE_TRIM_RANGES,
    trimRanges,
  };
};

export const updateTrimRedoStack = redoStack => {
  return {
    type: UPDATE_TRIM_REDO_STACK,
    redoStack,
  };
};

export const updateTrimUndoStack = undoStack => {
  return {
    type: UPDATE_TRIM_UNDO_STACK,
    undoStack,
  };
};
